import { useEffect } from 'react';

import { useJobProspectsStatsActions } from './JobProspectsStatsContext';
import { getJobProspectsStats } from './restApi';

const JobProspectsStatsDetailLoader = () => {
  const { initializeState, onResponse, onError } = useJobProspectsStatsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getJobProspectsStats({ onResponse, onError });
  }, []);

  return null;
};

export default JobProspectsStatsDetailLoader;
